//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      userInfo: {}, //用户信息
      orderId: "" //d当前服务订单id
    };
  },
  created() {
    if(!this.$store.state.userInfo.sessionId){
      this.$store.state.userInfo.sessionId = 'haozhongyi';
    }
    this.orderId = this.$route.query.orderId;
    this.query();
  },
  methods: {
    query() {
      var _this = this;
      var data = {
        orderID: this.orderId,
        getPatient: 1,
        isaction: 1
      };
      this.$doRequest("/api/Inquiry/orderDetails", data,function(res){
        _this.userInfo = res;
      });
    }
  },
  mounted() {}
};



// WEBPACK FOOTER //
// ./src/views/upload/twos/twos.vue